import $ from 'zepto';

/**
 * @method get Return xvx global variable if it does not exist on windows context, it defines the property.
 * Also, It adds initComponents with a shorthand for Zepto to listen document is ready for javascript.
 * @return {Object}
 */
const get = () => {
  if (!window.xvx) {
    Object.defineProperty(window, 'xvx', {
      value: { initializer: [] },
      writable: false,
    });
  }
  return window.xvx;
};

/**
 * @method expose Assigns properties to the xvx global variable.
 * @param {Object} obj object with properties.
 */
const expose = (obj) => {
  Object.assign(get(), obj);
};

/**
 * @function onDocumentReady Check initialize handler with a component name for execution when the document is ready.
 * @param {String} componentName Component's name.
 * @param {Function} initializerHandler is a function that contains instructions in which a component is initialized.
 */
const onDocumentReady = (componentName, initializerHandler) => {
  if (typeof initializerHandler === 'function') {
    const { initializer } = get();
    if (!initializer.includes(componentName)) {
      $(initializerHandler);
      initializer.push(componentName);
    }
  } else {
    throw new Error('InitializerHandler should be a function.');
  }
};

export {
  expose, get, onDocumentReady,
};
